<template>
  <nav
    ref="navwrapper"
    :class="{ 'inline': !inlineMenuOverflown, 'is-initialized': isInitialized }"
    class="nav-wrapper"
    aria-label="Navigering"
  >
    <div
      ref="menugroup"
      class="navigation__inline-menu-group"
    >
      <button
        v-if="inlineMenuOverflown"
        type="button"
        aria-label="meny"
        aria-haspopup="true"
        class="button--32 button--icon button--secondary"
        @click="toggle"
      >
        <svgicon
          name="Navigation/Menu"
          class="navigation__open-menu"
        />
      </button>
      <a
        v-if="!isStore"
        aria-label="ICA.se Startsida"
        class="navigation__logo-link"
        href="/"
        @click="onLogoClick"
      >
        <svgicon
          name="Logos/ICA"
          class="navigation__logo"
        />
      </a>
      <a
        v-else
        aria-label="Butikens startsida"
        class="navigation__logo-bhs-link"
        :href="storeUrl"
      >
        <profile-logo :profile="profile" />
      </a>
    </div>
    <div
      :class="{ 'open': active, 'in-transit': transitioning }"
      class="navigation"
    >
      <div
        v-if="inlineMenuOverflown"
        class="navigation__menu-group navigation__menu-group--take-over"
      >
        <button
          type="button"
          aria-label="Stäng menyn"
          class="button--32 button--icon button--secondary"
          @click="toggle"
        >
          <svgicon
            name="Controls/Close"
            class="navigation__close-menu"
          />
        </button>
        <a
          v-if="!isStore"
          aria-label="ICA.se Startsida"
          class="navigation__logo-link"
          href="/"
          @click="onLogoClick"
        >
          <svgicon
            name="Logos/ICA"
            class="navigation__logo"
          />
        </a>
        <a
          v-else
          aria-label="Butikens startsida"
          class="navigation__logo-bhs-link"
          :href="storeUrl"
        >
          <profile-logo :profile="profile" />
        </a>
      </div>
      <div
        v-if="isStore && inlineMenuOverflown"
        class="store-menu-header"
      >
        <p class="font-rubrik-1--bold store-header">
          {{ storeName }}
        </p>
      </div>
      <ul
        ref="inlineNavigationList"
        class="navigation__list"
      >
        <li
          v-for="item in menuItems"
          :key="item.label"
        >
          <a
            :class="{ active: item.isActive }"
            :href="item.url && item.url.endsWith('/handla/') && onlineUrl ? onlineUrl : item.url"
            class="navigation__item"
            @click="track.menuClick(item.label, item.url)"
            v-text="item.label"
          />
          <ul
            v-if="item.children && inlineMenuOverflown"
            class="navigation__sub-navigation"
          >
            <li
              v-for="subNav in item.children"
              :key="subNav.label"
            >
              <a
                :href="subNav.url"
                :target="subNav.target"
                class="navigation__item navigation--sub-navigation-item"
                @click="track.menuClick(subNav.label, subNav.url)"
                v-text="subNav.label"
              />
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
import profileLogo from "./profile-logos"
import ga from "@/analytics/dataLayerTopNav.js"
import { setTimeout } from "timers"
import "#/Navigation/Menu"
import "#/Logos/ICA"
import "#/Controls/Close"

export default {
  name: "NavigationComponent",
  components: {
    "profile-logo": profileLogo
  },
  props: {
    menuItems: {
      type: Array,
      default () {
        return []
      }
    },
    inlineMenuOverflown: {
      type: Boolean,
      default: false
    },
    isStore: {
      type: Boolean,
      default: false
    },
    storeName: {
      type: String,
      default: ""
    },
    storeUrl: {
      type: String,
      default: ""
    },
    onlineUrl: {
      type: String,
      default: ""
    },
    profile: {
      type: String,
      default: ""
    },
  },
  data () {
    return {
      active: false,
      transitioning: false,
      track: ga,
      isInitialized: false
    }
  },
  mounted () {
    if (this.$refs.inlineNavigationList) {
      this.$refs.inlineNavigationList.style.position = "fixed"
      this.$refs.inlineNavigationList.style.whiteSpace = "nowrap"

      //compensate for logo width, 60 is the widest store logo + 16 for right padding and + 1 for extra margin
      this.$emit(
        "initialWidth",
        parseInt(getComputedStyle(this.$refs.inlineNavigationList).width) + 77
      )
      this.isInitialized = true
      this.$refs.inlineNavigationList.style.position = ""
      this.$refs.inlineNavigationList.style.whiteSpace = ""
    }
  },
  beforeDestroy () {
    ResizeObserver.removeAllCallbacks(this)
  },
  methods: {
    toggle () {
      this.transitioning = true
      this.active = !this.active

      this.$nextTick(() => {
        if (this.active === true) {
          window.addEventListener("click", this.onDesktopClick)
          this.track.onOpenHamburgarMenu()
        } else {
          window.removeEventListener("click", this.onDesktopClick)
        }
      })

      setTimeout(() => {
        this.transitioning = false
      }, 250)
    },
    onDesktopClick (e) {
      let navigationClick = Array.from(
        this.$refs.navwrapper.getElementsByTagName(e.target.tagName)
      ).includes(e.target)
      if (!navigationClick) {
        this.toggle()
      }
    },
    onLogoClick () {
      this.track.logoClick()
    }
  }
}
</script>
<style lang="scss">
.nav-wrapper {
  display: flex;

  @ica-legacy {
    &.inline {
      margin-right: 0;
    }
  }
}

.navigation {
  .store-menu-header {
    margin: 0 1rem;

    .store-header {
      border-bottom: 1px solid $color-grey-lightest;
      margin: 0;
      padding: 1rem 0 1rem;
      text-align: left;
    }
  }

  &__menu-group,
  &__inline-menu-group {
    align-items: center;
    display: flex;
    padding: 1rem 0 1rem 0;
    font-size: 0;

    @include media-breakpoint-up(md) {
      padding-right: 1rem;
    }
  }

  &__menu-group {
    padding-left: 1rem;
    padding-right: 1rem;

    &--take-over {
      border-bottom: 1px solid $color-grey-special;
    }
  }

  &__logo-link {
    display: inline-block;
    height: 2rem;
    line-height: 2rem;
  }

  &__logo-bhs-link {
    font-size: 0;
    height: 2.5rem;
    margin-left: 1rem;
  }

  &__logo {
    fill: $color-red;
    height: 1.375rem;
    width: 2.75rem;
    margin: 5px 0 5px 0.5rem;

    @media (min-width: 20.063em) {
      margin: 5px 0 5px 1rem;
    }
  }

  &__list {
    overflow-y: auto;
    height: 100vh;
    opacity: 0;
    position: fixed;

    @include media-breakpoint-up(xl) {
      opacity: 1;
      position: relative;
    }

    .is-initialized & {
      opacity: 1;
      position: relative;
    }

    .inline & {
      overflow: visible;
      height: auto;
      align-self: center;

      li {
        display: inline-block;
      }
    }

    @ica-legacy {
      li {
        display: block;
      }
    }
  }

  &__item {
    @include font(text, 3);

    color: $color-grey-dark;
    display: block;
    margin: 0;
    padding: 1rem 1rem;
    text-decoration: none;
    position: relative;

    &.active {
      color: $color-red-dark;
      font-weight: bold;

      .nav-wrapper.inline & {
        &::after {
          content: " ";
          display: block;
          position: absolute;
          background: $color-red-dark;
          left: 0.5rem;
          right: 0.5rem;
          bottom: -0.25rem;
          height: 2px;
        }
      }
    }
  }

  &__sub-navigation {
    background-color: $color-grey-lightest;

    @include media-breakpoint-up(lg) {
      display: none;
    }
  }

  &--sub-navigation-item {
    padding: 0.75rem 0.75rem;
  }

  .inline & {
    display: flex;
    order: 1;

    &__menu-group,
    &__open-menu,
    &__sub-navigation {
      display: none;
    }

    &__logo,
    &__logo-bhs-link {
      margin-left: 0;
    }

    &__item {
      display: inline-block;
      padding: 0 0.5rem;
    }
  }

  .nav-wrapper:not(.inline) & {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    visibility: hidden;
    width: 100%;
    height: 100vh;
    background-color: $color-white;
    transform: translateX(-130%);
    box-shadow: 0 0 1.25rem 0 rgba(50, 50, 50, 0.2);

    @include media-breakpoint-up(md) {
      width: 16rem;
    }

    &.in-transit {
      transition: transform 0.2s ease-in-out;
    }

    &.open {
      transform: translateX(0);
      visibility: visible;
    }
  }
}

.nav-wrapper:not(.inline) li:first-child .navigation__item {
  padding-top: 1.5rem;
}
</style>
